// src/components/SectionFive.jsx

import React from "react";
import { Grid, Box, Typography, Button } from "@mui/material";
import { Link } from "react-router-dom";

// Main image

import bgTop from "../../../assets/centrum_assets/design/index/fourthPICTURE.png"

// Decorative lines
import greenline from "../../../assets/centrum_assets/design/index/vectorGreenInverted.png";
import blueline from "../../../assets/centrum_assets/design/index/vectorBlueInverted.png";
import BlueLine from "../../components/BlueLine";

const SectionFive = () => {
  return (
     <Box sx={{ width: "100%", position: "relative" }}>
      <Grid
        container
        spacing={2}
        direction={{ xs: "column", md: "row" }}
        alignItems="center"
        sx={{ position: "relative"}} 
      >
        {/* IMAGE */}
        <Grid item xs={12} md={6}>
          <Box
            component="img"
            src={bgTop}
            alt="Background Image"
            sx={{
              width: "100%",
              maxWidth: "100%",
              height: "auto",
              display: "block",
              ml: { md: "-100px" },
            }}
          />
        </Grid>

        {/* TEXT */}
        <Grid item xs={12} md={6}>
          <Box sx={{ textAlign: { md: "left" }, p: 5 }}>
            <Typography
              variant="h5"
              sx={{ mb: 0.5, fontWeight: "bold", color: "#00b5e2", fontSize: {md: '1.5rem', xs: '2rem'} }}
            >
              YOUR PARTNER TOWARDS GROWTH
            </Typography>

            <Typography
              variant="h2"
              sx={{
                color: "#0a1a3b",
                fontWeight: 800,
                mb: 2,
                lineHeight: 1.2,
                letterSpacing: ".2px",
              }}
            >
              BUILDING STRONG <br/> RELATIONSHIPS
            </Typography>

            <BlueLine height="60%">
              <Typography
                // variant="h4"
                sx={{
                  color: "#5f5f5f",
                  lineHeight: 1.5,
                  mb: 3,
                  fontSize: {md: '2.1rem', xs: '2.4rem'},
                  maxWidth: 600,
                }}
              >
                Centrum Fuel is proud to be a part of the communities we serve,
                and we’re always looking for ways to grow, expand, and reach
                more people. We hope you’ll be one of the partners who joins us
                on this journey.
              </Typography>
            </BlueLine>

            <Box sx={{ textAlign: { xs: "left", md: "left" }, py: 2 }}>
              <Button
               component={Link}
                to="/franchise"
                variant="contained"
                sx={{
                  borderRadius: 20,
                  fontWeight: 600,
                  // letterSpacing: 1,
                  px: 3.5,
                  letterSpacing: "5px",
                  fontSize: {md: "1.25rem", xs: '1.5rem'},
                  backgroundColor: "#00b5e2",
                  "&:hover": {
                    backgroundColor: "#009ecb",
                  },
                }}
              >
                INQUIRE NOW
              </Button>
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Box
       component="img"
        src={greenline}
        alt="Green decorative line"
        sx={{
        position: { xs: "relative", md: "absolute" },
        bottom: 0,
        left: 0,
        width: { md: "50%" },
        zIndex: 5,
        mt: { xs: 3, md:0 },
        mb: { xs: 4, md: 0 },
        transformOrigin: "bottom",
        transform: { xs: "translate(50%, 0%) scale(3)", sm : "translate(0%, 20%) scale(2.5)", md: 'translate(0%, 20%) scale(1)', },
        }}
      />


      <Box
       component="img"
        src={blueline}
        alt="Blue decorative line"
        sx={{
        position: { xs: "relative", md: "absolute" },
        bottom: 0,
        left: 0,
        width: "100%",
        zIndex: 6,
        mt: { xs: -4, md: 0 },
        mb: { xs: 3, md: 0 },
        transformOrigin: "bottom",
        // transform: { xs: "scaleY(2)", md: "scaleY(1)" },
         transform: { xs: "translate(50%, 200%) scale(5)",sm : "translate(20%, 180%) scale(4)",  md: 'translate(0%, 80%) scale(1)', },
    }}
  />
    </Box>
  );
};

export default SectionFive;
